<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<div class="popup" [dir]="locale.lang === 'en' ? 'ltr' : 'rtl'">
    <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>

       <h4 fxFlex="auto"> {{ locale.translations['ads']['comment']['n278'] }}</h4>
        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
          <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-divider class="-mx-6 text-border"></mat-divider>
    <div class="reply_list">
        <div class="mdc-layout-grid__cell--span-12" *ngFor="let _commentList of commentListArr  ; let i =  index " >

            <ul class="details_wrap mdc-layout-grid__cell--span-12">
                <div *ngIf="_commentList.status ==='1'" class="w-100 d-flex">
                <li class=" px-4">
                    <p >
                        <strong>{{_commentList.name}}</strong> <span  *ngIf="_commentList.userID === data['userAd']" class="owner_btn mx-1">{{ locale.translations['ads']['comment']['n283'] }}</span>
                    </p>
                    <p >
                        {{ _commentList.comment}}
                    </p>
          <p *ngIf="_commentList.replies !=='0' && _commentList.status ==='1' &&_commentList.replies !=='1'" class="purple_color"
                        (click)="openReplyDialog(_commentList.id)"> {{ locale.translations['ads']['comment']['n282'] }} {{_commentList.replies}} {{ locale.translations['ads']['comment']['n280'] }}
                    </p>

            <p class="purple_color" *ngIf="_commentList.replies !=='0' && _commentList.status ==='1' &&_commentList.replies ==='1'" (click)="openReplyDialog(_commentList.id)" class="purple_color">
                {{ locale.translations['ads']['comment']['n282'] }} {{_commentList.replies}} {{ locale.translations['ads']['comment']['n281'] }}

            </p>
                </li>
                <li class="text-center pt-3">
                    <span class="time">{{_commentList.createdAt}} {{ locale.translations['ads']['ad']['n303'] }}<br /></span>

                    <ng-container *ngIf="this.user">

                        <span *ngIf="getToggle(_commentList)">
                            <button (click)="toggle(_commentList.id,_commentList.status)" mat-icon-button matSuffix
                                matTooltip="Toggle Visibility" type="button">
                                <mat-icon *ngIf="_commentList.status ==='1'">visibility_off</mat-icon>
                                <mat-icon *ngIf="_commentList.status ==='2'">visibility_on</mat-icon>
                            </button><br />
                        </span>

                    </ng-container>
                    <ng-container *ngIf="_commentList.status ==='1'">

                        <button mat-icon-button color="primary" title="Reply"
                            (click)="openReplyDialog(_commentList.id)">
                            {{ locale.translations['ads']['comment']['n281'] }} </button>

                    </ng-container>
                </li>
                </div>

                <div *ngIf="_commentList.status ==='2'" class="gray_bg w-100 d-flex" >
                    <li class="px-4">
                        <p >
                            <strong>{{_commentList.name}}</strong> <span  *ngIf="_commentList.userID === data['userAd']" class="owner_btn mx-1">{{ locale.translations['ads']['comment']['n283'] }}</span>
                        </p>
                        <p>
                            {{ _commentList.comment}}
                        </p>



                        <p *ngIf="_commentList.replies !=='0' && _commentList.status ==='1' &&_commentList.replies !=='1'" class="purple_color"
                            (click)="openReplyDialog(_commentList.id)"> {{ locale.translations['ads']['comment']['n282'] }} {{_commentList.replies}} {{ locale.translations['ads']['comment']['n280'] }}
                        </p>

                <p class="purple_color" *ngIf="_commentList.replies !=='0' && _commentList.status ==='1' &&_commentList.replies ==='1'" (click)="openReplyDialog(_commentList.id)" class="purple_color">
                    {{ locale.translations['ads']['comment']['n282'] }} {{_commentList.replies}} {{ locale.translations['ads']['comment']['n281'] }}

                </p>
                    </li>
                    <li class="text-center pt-3">
                        <span class="time">{{_commentList.createdAt}} {{ locale.translations['ads']['ad']['n303'] }}<br /></span>

                        <ng-container *ngIf="this.user">

                            <span *ngIf="getToggle(_commentList)">
                                <button (click)="toggle(_commentList.id,_commentList.status)" mat-icon-button matSuffix
                                    matTooltip="Toggle Visibility" type="button">
                                    <mat-icon *ngIf="_commentList.status ==='1'">visibility_off</mat-icon>
                                    <mat-icon *ngIf="_commentList.status ==='2'">visibility_on</mat-icon>
                                </button><br />
                            </span>

                        </ng-container>
                        <ng-container *ngIf="_commentList.status ==='1'">

                            <button mat-icon-button color="primary" title="Reply"
                                (click)="openReplyDialog(_commentList.id)">
                                {{ locale.translations['ads']['comment']['n281'] }} </button>

                        </ng-container>
                    </li>
                    </div>
            </ul>
        </div>
    </div>
    <ng-container *ngIf="load">
        <span (click)="LoadMore()" class  ="load_btn">
            {{ locale.translations['ads']['ad']['n302'] }} <span *ngIf="showLoad"><img [src]="'/assets/images/loading.gif' | s3Image"></span>
        </span>
    </ng-container>
    <div class="comment_footer">
        <div class="mdc-layout-grid__cell--span-12">
            <textarea class="type_a_comment" [(ngModel)]="comment" placeholder=" {{ locale.translations['ads']['comment']['n284'] }}"></textarea>
            <button  *ngIf="locale.lang === 'en'" mat-icon-button color="primary" [disabled]="!comment" (click)="addComment(comment)" class="go_btn">
                <mat-icon> send </mat-icon>
            </button>
            <button  *ngIf="locale.lang === 'ku'" mat-icon-button color="primary" [disabled]="!comment" (click)="addComment(comment)" class="go_btn_rev">
                <mat-icon> send </mat-icon>
            </button>
            <button  *ngIf="locale.lang === 'ar'" mat-icon-button color="primary" [disabled]="!comment" (click)="addComment(comment)" class="go_btn_rev">
                <mat-icon> send </mat-icon>
            </button>
        </div>
    </div>
</div>

